export enum BluesnapECPAccountType {
    ConsumerChecking = 'CONSUMER_CHECKING',
    ConsumerSavings = 'CONSUMER_SAVINGS',
    CorporateChecking = 'CORPORATE_CHECKING',
    CorporateSavings = 'CORPORATE_SAVINGS',
}
